namespace $.$$ {

	$mol_style_define( $shm_projects_tasks_panel, {
		List_head: {
			Head: {
				alignItems: 'center',
			},
		},
		Sort_menu: {
			margin: {
				left: 'auto',
			},
		},
	} )

}
